import { all } from "redux-saga/effects";
import beneficiarySaga from "./beneficiary/sagas";
import casesSaga from "./cases/sagas";
import consentSaga from "./consent/sagas";
import downtimeSaga from "./downtime/saga";
import interviewSaga from "./interview/sagas";
import physicianSaga from "./physician/sagas";
import signingSaga from "./signing/sagas";
import singleCaseSaga from "./singleCase/sagas";

function* rootSaga() {
  yield all([
    interviewSaga(),
    physicianSaga(),
    casesSaga(),
    singleCaseSaga(),
    consentSaga(),
    signingSaga(),
    beneficiarySaga(),
    downtimeSaga(),
  ]);
}

export default rootSaga;
